import { LinkButton } from './LinkButton';
import { ButtonsRoot } from './ButtonsRoot';
import { FooterButtonsRoot } from './FooterRoot';

export const FooterButtons = {
  Root: FooterButtonsRoot,
  Link: LinkButton,
  ButtonRoot: ButtonsRoot,
};
